import { AiOutlineSketch, AiOutlineQuestionCircle, AiOutlineHome } from 'react-icons/ai'
import { TbMail } from 'react-icons/tb'
import { HiOutlineAcademicCap } from 'react-icons/hi'
import { MdOutlineRocketLaunch } from 'react-icons/md'
import { RiVipFill } from 'react-icons/ri'
import ContentPaperEdit from '../../assets/icons/content-paper-edit'
import { TAppPath } from '../../hooks/use-get-app-routes'
import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar.svg'
import { RxCalendar } from 'react-icons/rx'

export const RoutesIcons: Record<TAppPath, JSX.Element> = {
  '/home': <AiOutlineHome size={25} />,
  '/planejamento': <RxCalendar size={25} />,
  '/questoes': <ContentPaperEdit width={24} />,
  '/course/652d448fc0734d00343ba192': <RiVipFill size={24} />,
  '/premium': <RiVipFill size={24} />,
  '/my-contents': <HiOutlineAcademicCap size={25} />,
  '/desempenho': <MdOutlineRocketLaunch size={24} />,
  '/subscription': <AiOutlineSketch size={25} />,
  '/duvidas': <AiOutlineQuestionCircle size={23} style={{ marginTop: '-0.2rem' }} />,
  '/recados': <TbMail size={23} style={{ marginTop: '-0.2rem' }} />,
  '/prazos': <CalendarIcon style={{ marginTop: '-0.2rem', width: 23 }} />,
}
